<section class="grid-container">
    <tabs (tabClicked)="onTabClicked()">
        <tab title="Bonding">
            <fa-bonding [orgId]="orgId" [isRecalculating]="isRecalculating" [isLoading]="complianceIsLoading" [complianceDetails]="complianceDetail" (recalculateEvent)="recalculate($event)" [gridAriaLabel]="widgetTitle + ' - Bonding'"></fa-bonding>
        </tab>
        <tab title="Insurance">
            <fa-insurance [orgId]="orgId" [isRecalculating]="isRecalculating" [isLoading]="complianceIsLoading" [complianceDetails]="complianceDetail" (recalculateEvent)="recalculate($event)" [gridAriaLabel]="widgetTitle + ' - Insurance'"></fa-insurance>
        </tab>
        <tab title="Not Submitted">
            <fa-not-submitted-flow [orgId]="orgId" [gridAriaLabel]="widgetTitle + ' - Not Submitted'"></fa-not-submitted-flow>
        </tab>
        <tab title="Pending">
            <fa-pending [orgId]="orgId" [isInternal]="false" [gridAriaLabel]="widgetTitle + ' - Pending'"></fa-pending>
        </tab>
        <tab title="Returned">
            <fa-returned-flow [orgId]="orgId" [gridAriaLabel]="widgetTitle + ' - Returned'"></fa-returned-flow>
        </tab>
    </tabs>

</section>